// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadLoading {
  display: flex;
  align-items: center;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.UploadLoading .UploadLoading-icon {
  color: var(--color_primary_300);
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  animation: spin 1.6s linear infinite;
  will-change: transform;
}
.UploadLoading .UploadLoading-text {
  color: var(--color_neutral_0);
  font-weight: 400;
  white-space: nowrap;
}
.UploadLoading.UploadLoading--solid {
  background: #000000;
  border-radius: 12px;
  padding: 8px 12px;
  gap: 8px;
}
.UploadLoading.UploadLoading--solid .UploadLoading-text {
  font-size: 12px;
  line-height: 1.5;
}
.UploadLoading.UploadLoading--default {
  gap: 16px;
}
.UploadLoading.UploadLoading--default .UploadLoading-text {
  font-size: 14px;
  line-height: normal;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/documents/upload-loading/upload-loading.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AACF;AACE;EACE,+BAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,sBAAA;AACJ;AAEE;EACE,6BAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;AADJ;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAKE;EACE,SAAA;AAHJ;AAKI;EACE,eAAA;EACA,mBAAA;AAHN;;AAQA;EACE;IACE,uBAAA;EALF;EAOA;IACE,yBAAA;EALF;AACF","sourcesContent":[".UploadLoading {\n  display: flex;\n  align-items: center;\n  width: fit-content;\n\n  .UploadLoading-icon {\n    color: var(--color_primary_300);\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    animation: spin 1.6s linear infinite;\n    will-change: transform;\n  }\n\n  .UploadLoading-text {\n    color: var(--color_neutral_0);\n    font-weight: 400;\n    white-space: nowrap;\n  }\n\n  &.UploadLoading--solid {\n    background: #000000; // we don't have a variable for this color yet\n    border-radius: 12px;\n    padding: 8px 12px;\n    gap: 8px;\n\n    .UploadLoading-text {\n      font-size: 12px;\n      line-height: 1.5;\n    }\n  }\n\n  &.UploadLoading--default {\n    gap: 16px;\n\n    .UploadLoading-text {\n      font-size: 14px;\n      line-height: normal;\n    }\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
